import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'

interface AdminPageHeaderProps {
  title: string
  subtitle?: string
  backLabel?: string
  onBack?: () => void
  headerAside?: ReactNode
}

export function AdminPageHeader({
  title,
  subtitle,
  backLabel = 'Back to Dashboard',
  onBack,
  headerAside,
}: AdminPageHeaderProps) {
  return (
    <div className='bg-white px-6 py-6 sm:px-8'>
      <div className='space-y-4'>
        {onBack && (
          <button
            onClick={onBack}
            className='inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-md px-2 py-1 -ml-2'
          >
            <ArrowLeft className='h-4 w-4' />
            {backLabel}
          </button>
        )}

        <div className='space-y-3'>
          <div className='space-y-1'>
            <h1 className='text-2xl font-bold text-foreground'>{title}</h1>
            {subtitle && (
              <p className='text-sm text-muted-foreground'>{subtitle}</p>
            )}
          </div>
          {headerAside && (
            <div className='flex flex-wrap items-center gap-2'>
              {headerAside}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
